var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 650,
    viewBox: "0 0 986 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic to Export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.87 490.151C548.387 455.361 510.57 432 467.277 432C408.056 432 359.056 475.685 350.709 532.584C342.324 533.181 335.628 539.846 334.992 548.22C331.61 547.099 328.001 546.484 324.244 546.484C305.373 546.484 290.075 561.776 290.075 580.642C290.075 580.921 290.084 581.198 290.094 581.475C290.097 581.551 290.099 581.628 290.102 581.704C280.131 576.334 268.803 573.173 256.766 572.827C253.889 559.5 242.035 549.51 227.842 549.51C211.496 549.51 198.246 562.757 198.246 579.097C198.246 581.795 198.615 584.408 199.292 586.893C195.006 584.481 190.062 583.097 184.792 583.097C177.603 583.097 171.014 585.663 165.885 589.923C152.918 579.21 136.285 572.772 118.149 572.772C88.0835 572.772 62.177 590.469 50.2246 616H934.225L933.932 615.413C929.243 606.283 919.742 600.029 908.771 600.029C904.316 600.029 900.119 601.09 896.369 602.924C890.915 581.205 872.373 564.687 849.611 562.238C847.134 561.851 844.597 561.647 842.01 561.647C829.632 561.647 818.334 566.237 809.701 573.796C799.568 546.309 773.136 526.705 742.12 526.705C736.381 526.705 730.799 527.381 725.447 528.65C725.623 527.506 725.741 526.343 725.741 525.15C725.741 512.411 715.413 502.084 702.673 502.084C698.171 502.084 693.983 503.394 690.433 505.625C681.238 478.78 655.802 459.474 625.839 459.474C602.029 459.474 581.086 471.672 568.87 490.151ZM352.948 531.184C361.949 475.543 410.196 434 467.277 434C508.785 434 546.458 456.027 567.146 491.166L568.772 493.926L570.538 491.254L571.09 490.432C583.352 472.465 603.655 461.474 625.839 461.474C654.382 461.474 679.435 479.69 688.541 506.273L689.359 508.663L691.498 507.319L692.13 506.936C695.322 505.079 698.925 504.084 702.673 504.084C714.308 504.084 723.741 513.516 723.741 525.15C723.741 526.146 723.65 527.179 723.47 528.347L723.02 531.281L725.909 530.596L727.352 530.27C732.176 529.233 737.117 528.705 742.12 528.705C771.69 528.705 797.766 547.203 807.825 574.487L808.831 577.216L811.019 575.3L811.756 574.668C820.172 567.596 830.782 563.647 842.01 563.647C844.46 563.647 846.894 563.838 849.302 564.214C871.145 566.566 889.134 582.326 894.429 603.411L895.03 605.806L897.247 604.721L898.024 604.356C901.406 602.831 905.039 602.029 908.771 602.029L909.433 602.037C918.018 602.252 925.786 606.621 930.483 613.516L930.803 614H53.4446L53.6862 613.542C66.2117 589.956 90.7986 574.772 118.149 574.772C135.348 574.772 151.627 580.738 164.611 591.465L165.889 592.521L167.163 591.462L167.76 590.98C172.58 587.194 178.523 585.097 184.792 585.097C189.59 585.097 194.21 586.328 198.311 588.636L202.477 590.98L201.222 586.368L200.995 585.477C200.499 583.39 200.246 581.255 200.246 579.097C200.246 563.862 212.601 551.51 227.842 551.51C240.9 551.51 252.092 560.651 254.811 573.249L255.142 574.781L256.708 574.826L257.939 574.872C268.996 575.372 279.608 578.324 289.154 583.465L292.214 585.113L292.101 581.639L292.075 580.642C292.075 562.881 306.477 548.484 324.244 548.484C327.713 548.484 331.112 549.041 334.363 550.118L336.792 550.923L336.986 548.371L337.031 547.881C337.81 540.726 343.62 535.094 350.851 534.579L352.454 534.465L352.688 532.874L352.948 531.184Z",
    fill: "url(#paint0_linear_527:46028)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Divider",
    x: 0.224609,
    y: 614,
    width: 984,
    height: 2,
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.438 58.866C477.853 30.1327 422.345 16.7494 359.457 28.9736C296.569 41.1978 250.116 74.4004 255.701 103.134C261.286 131.867 316.794 145.25 379.682 133.026C442.57 120.802 489.023 87.5993 483.438 58.866ZM257.664 102.752C252.371 75.523 297.909 42.9747 359.838 30.9368C421.768 18.899 476.182 32.0185 481.475 59.2476C486.768 86.4766 441.23 119.025 379.301 131.063C317.371 143.101 262.957 129.981 257.664 102.752Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 388,
    cy: 149.62,
    rx: 280,
    ry: 93,
    transform: "rotate(-12 388 149.62)",
    fill: "url(#paint1_linear_527:46028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M84.1555 226.415C86.5668 237.759 94.3883 247.742 107.278 256.126L108.165 256.695L107.095 258.385C93.5619 249.812 85.1673 239.483 82.3805 227.641L82.1992 226.831L84.1555 226.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M94.0071 215.149C97.7943 232.966 115.219 247.335 144.419 257.232L146.718 257.994L146.101 259.897C142.25 258.648 138.588 257.324 135.12 255.926L133.062 255.078C110.002 245.367 95.9261 232.245 92.2081 216.271L92.0508 215.564L94.0071 215.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M674.687 53.4666C669.422 43.1331 659.283 35.5149 644.662 30.7526L643.658 30.4323L644.255 28.5234C659.545 33.3015 670.327 41.1062 676.084 51.8234L676.469 52.5586L674.687 53.4666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M668.087 66.8992C659.818 50.6692 639.268 41.2996 608.501 39.2972L606.083 39.1561L606.186 37.1588C610.229 37.368 614.109 37.6994 617.821 38.1525L620.029 38.439C644.816 41.8507 661.809 50.8825 669.534 65.3494L669.869 65.9912L668.087 66.8992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy",
    cx: 170.225,
    cy: 161.027,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2",
    cx: 196.225,
    cy: 145.027,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 148.225,
    cy: 179.027,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 386.337,
    cy: 157.794,
    rx: 124,
    ry: 42,
    transform: "rotate(-12 386.337 157.794)",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.933 134.925C490.029 116.557 438.692 111.907 379.268 124.538C319.844 137.169 274.837 162.298 278.741 180.665C282.645 199.033 333.982 203.683 393.406 191.052C452.83 178.421 497.837 153.292 493.933 134.925ZM340.605 137.261C352.51 133.151 365.692 129.468 379.684 126.494C393.676 123.52 407.216 121.523 419.764 120.436L422.88 120.183C461.048 117.296 489.355 123.006 491.977 135.34C495.52 152.009 451.291 176.703 392.99 189.096C334.689 201.488 284.24 196.918 280.697 180.249C278.075 167.915 301.613 151.185 337.655 138.298L340.605 137.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365 224L318.225 616.539H638.345L426 213C426 213 417 221 397 224C377 227 365 224 365 224Z",
    fill: "url(#paint2_linear_527:46028)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    cx: 478,
    cy: 617,
    rx: 160,
    ry: 31,
    fill: "url(#paint3_radial_527:46028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.891 224.265C441.027 215.308 468.484 176.517 460.216 137.621C460.111 137.124 460 136.628 459.883 136.136C458.748 131.327 454.91 127.684 450.111 126.505C429.702 121.493 404.72 121.175 378.706 126.704C352.118 132.356 328.999 143.149 312.303 156.422C308.447 159.487 306.489 164.382 307.452 169.212C307.508 169.493 307.566 169.774 307.625 170.055C315.893 208.951 356.754 233.221 398.891 224.265Z",
    fill: "url(#paint4_radial_527:46028)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "System Icon /Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.079 348.128C399.008 340.199 411.25 339.21 420.254 345.162L433.824 331.592L440.385 338.153L426.822 351.716C432.804 360.724 431.824 372.991 423.883 380.932C414.825 389.99 400.138 389.99 391.079 380.932C382.021 371.873 382.021 357.186 391.079 348.128ZM397.64 374.371C403.075 379.806 411.887 379.806 417.322 374.371C422.757 368.936 422.757 360.124 417.322 354.688C411.887 349.253 403.075 349.253 397.64 354.688C392.205 360.124 392.205 368.936 397.64 374.371Z",
    fill: "#0F214F"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 414.666,
    y: 273.59,
    width: 8,
    height: 8,
    transform: "rotate(29 414.666 273.59)",
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.03 396.956L481.422 402.956L487.422 392.563L477.03 386.563L471.03 396.956ZM484.691 393.294L480.691 400.222L473.762 396.222L477.762 389.294L484.691 393.294Z",
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy",
    x: 390.877,
    y: 452.784,
    width: 8,
    height: 8,
    transform: "rotate(-15 390.877 452.784)",
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.036 523.135L459.066 502.744C459.655 512.92 454.202 523.449 442.707 534.331C431.211 545.213 414.48 552.283 392.514 555.54L454.096 618.301C470.07 606.979 482.445 592.499 491.222 574.861C499.999 557.223 505.27 539.981 507.036 523.135ZM461.048 506.098L461.063 505.766L504.883 524.394L504.667 526.144C502.621 541.722 497.546 557.663 489.431 573.97L488.743 575.333C480.623 591.156 469.51 604.334 455.389 614.886L454.32 615.673L396.649 556.9L398.284 556.609C417.965 552.973 433.243 546.044 444.082 535.783C454.702 525.729 460.403 515.834 461.048 506.098Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.468 458.007C470.468 458.007 462.792 488.992 438.044 501.261C413.296 513.53 389.617 511.896 389.617 511.896L441.278 589.879C441.278 589.879 476.744 584.524 500.03 557.356C523.315 530.188 535.171 485.541 535.171 485.541L470.468 458.007Z",
    fill: "#0F214F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.838 489.519C470.375 489.279 470.951 489.02 471.526 488.75C471.526 488.75 478.336 492.643 488.87 497.66C499.405 502.677 511.971 507.191 511.971 507.191L511.422 508.99C511.22 509.653 510.077 510.603 510.077 510.603C510.077 510.603 490.957 503.218 484.357 499.972C477.758 496.726 467.173 491.011 467.173 491.011C467.098 490.746 468.306 490.205 469.838 489.519ZM460.635 498.78C461.211 498.476 461.797 498.166 462.45 497.9C462.45 497.9 469.046 502.149 479.304 507.715C489.561 513.282 501.873 518.454 501.873 518.454L501.232 520.222C500.995 520.874 499.806 521.762 499.806 521.762C499.806 521.762 481.099 513.377 474.678 509.787C468.258 506.196 457.985 499.929 457.985 499.929C458.965 499.661 459.789 499.226 460.635 498.78Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527:46028",
    x1: 248.43,
    y1: 420.601,
    x2: 285.017,
    y2: 634.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#ADF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_527:46028",
    x1: 341.561,
    y1: 101.716,
    x2: 398.103,
    y2: 309.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#ADF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_527:46028",
    x1: 401,
    y1: 248,
    x2: 587.064,
    y2: 499.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_527:46028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(761.228 1202.42) rotate(30.5184) scale(49.316 86.4511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FEFD",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_527:46028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.837 121.616) rotate(90) scale(104.085 191.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77DDFB",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResult);
export default __webpack_public_path__ + "static/media/No-Search-Result.a40e4de56885f0908833f8f383557b74.svg";
export { ForwardRef as ReactComponent };